import React from "react";
import { Pagination, PaginationItem } from "@mui/material";
import {
  FirstPage,
  LastPage,
  KeyboardArrowLeft,
  KeyboardArrowRight,
} from "@mui/icons-material";

function CustomPagination({ messagesData, page, setPage, rowsPerPage }) {
  const totalPages = Math.ceil(messagesData.meta.total / rowsPerPage);
  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1); // Pagination uses 1-based index, convert to 0-based
  };

  return (
    <Pagination
      count={totalPages}
      page={page + 1} // Convert 0-based to 1-based for display
      onChange={handleChangePage}
      renderItem={(item) => {
        if (item.type === "start-ellipsis") {
          // Replace start-ellipsis with FirstPage button
          return (
            <PaginationItem
              component={FirstPage}
              disabled={page === 0}
              onClick={() => setPage(0)}
            />
          );
        }
        if (item.type === "end-ellipsis") {
          // Replace end-ellipsis with LastPage button
          return (
            <PaginationItem
              component={LastPage}
              disabled={page === totalPages - 1}
              onClick={() => setPage(totalPages - 1)}
            />
          );
        }
        if (item.type === "previous") {
          return <PaginationItem {...item} component={KeyboardArrowLeft} />;
        }
        if (item.type === "next") {
          return <PaginationItem {...item} component={KeyboardArrowRight} />;
        }
        return <PaginationItem {...item} />;
      }}
      siblingCount={1} // Show 1 page on each side of the current page
      boundaryCount={1} // Show 1 page at the start and end
    />
  );
}

export default CustomPagination;
